
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";

export function UserTableHeader() {
  return (
    <TableHeader className="bg-accent-subtle/30">
      <TableRow className="border-b border-accent-light/30">
        <TableHead className="font-section text-primary">Name</TableHead>
        <TableHead className="font-section text-primary">Email</TableHead>
        <TableHead className="font-section text-primary">School District</TableHead>
        <TableHead className="font-section text-primary">School</TableHead>
        <TableHead className="font-section text-primary">Position</TableHead>
        <TableHead className="font-section text-primary">Role</TableHead>
        <TableHead className="font-section text-primary">Status</TableHead>
        <TableHead className="text-right font-section text-primary">Actions</TableHead>
      </TableRow>
    </TableHeader>
  );
}
